// chatWoot 用户标识码
export const ChatWootUserIdentifier = 'k8cyFqgDxK1hJBiGZ5gAQU9b'
// chatWoot 页面标识码
export const ChatWootWebToken = 'KMh1hpiW5Wa5hPSBsv5FRbaF'
// chatWoot 基础地址
export const ChatWootBaseUrl = 'https://chat.ab771.com'

export const DefaultGameIndexIdentifier = 'defaultGameIndex'

// 首页弹窗banner已展示的登录会话(token)
export const PopupBannerShownIdentifier = 'popupBannerShownToken'
